<template>
  <!-- 新增模态框 -->
  <el-dialog title="发送通知" :visible.sync="sendFlags" width="50%" :before-close="clear" :close-on-click-modal="false">
    <el-form
      ref="form"
      :model="sendData"
      label-width="90px"
      :rules="sendDataRules"
      label-position="center"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="发送类型" prop="sendType">
            <el-select
              v-model="sendData.sendType"
              clearable filterable
              placeholder="请选择"
            >
              <el-option label="全部" :value="0"></el-option>
              <el-option label="自定义" :value="1"></el-option>
              <!-- <el-option label="私发"  :value="-1"></el-option> -->
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="发送类型">
            <el-radio-group v-model="sendData.type">
              <el-radio :label="1">站内信</el-radio>
              <el-radio :label="2">小程序通知</el-radio>
              <el-radio :label="3">短信</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" v-if="sendData.sendType == 1">
          <el-form-item label="发布范围">
            <el-radio-group v-model="sendData.radioType" @change="changeFlags">
              <el-radio :label="1">楼栋</el-radio>
              <el-radio :label="2">单元</el-radio>
              <el-radio :label="3">楼层</el-radio>
              <el-radio :label="4">房间</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="sendData.sendType == 1 && sendData.radioType == 1">
        <el-col :span="8">
          <el-form-item label="楼栋信息">
            <el-select
              v-model="sendData.ridgepoleId"
              clearable filterable
              multiple
              placeholder="请选择"
            >
              <el-option
                v-for="item in ridgepoleList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="sendData.radioType == 2">
        <el-col :span="8">
          <el-form-item label="楼栋信息">
            <el-select
              v-model="sendData.ridgepoleId"
              clearable filterable
              placeholder="请选择"
              @change="ridgepoleSelect"
            >
              <el-option
                v-for="item in ridgepoleList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="单元信息">
            <el-select
              v-model="sendData.unitId"
              clearable filterable
              multiple
              placeholder="请选择"
            >
              <el-option
                v-for="item in unitList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="sendData.radioType == 3">
        <el-col :span="8">
          <el-form-item label="楼栋信息">
            <el-select
              v-model="sendData.ridgepoleId"
              clearable filterable
              placeholder="请选择"
              @change="ridgepoleSelect"
            >
              <el-option
                v-for="item in ridgepoleList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="单元信息">
            <el-select
              v-model="sendData.unitId"
              clearable filterable
              placeholder="请选择"
              @change="unitSelect"
            >
              <el-option
                v-for="item in unitList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="楼层信息">
            <el-select
              v-model="sendData.floorId"
              clearable filterable
              multiple
              placeholder="请选择"
            >
              <el-option
                v-for="item in floorList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="sendData.radioType == 4">
        <el-col :span="8">
          <el-form-item label="楼栋信息">
            <el-select
              v-model="sendData.ridgepoleId"
              clearable filterable
              placeholder="请选择"
              @change="ridgepoleSelect"
            >
              <el-option
                v-for="item in ridgepoleList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="单元信息">
            <el-select
              v-model="sendData.unitId"
              clearable filterable
              placeholder="请选择"
              @change="unitSelect"
            >
              <el-option
                v-for="item in unitList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="楼层信息">
            <el-select
              v-model="sendData.floorId"
              clearable filterable
              placeholder="请选择"
              @change="floorSelect"
            >
              <el-option
                v-for="item in floorList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="sendData.radioType == 4">
        <el-col :span="24">
          <el-form-item label="房间信息">
            <el-select
              v-model="sendData.roomId"
              multiple
              clearable filterable
              placeholder="请选择"
            >
              <el-option
                v-for="item in roomList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="sendData.sendType == -1">
        <el-col :span="8">
          <el-form-item label="楼栋信息">
            <el-select
              v-model="sendData.ridgepoleId"
              clearable filterable
              placeholder="请选择"
              @change="ridgepoleSelect"
            >
              <el-option
                v-for="item in ridgepoleList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="单元信息">
            <el-select
              v-model="sendData.unitId"
              clearable filterable
              placeholder="请选择"
              @change="unitSelect"
            >
              <el-option
                v-for="item in unitList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="楼层信息">
            <el-select
              v-model="sendData.floorId"
              clearable filterable
              placeholder="请选择"
              @change="floorSelect"
            >
              <el-option
                v-for="item in floorList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="sendData.sendType == -1">
        <el-col :span="24">
          <el-form-item label="房间信息">
            <el-select v-model="sendData.roomId" clearable filterable placeholder="请选择">
              <el-option
                v-for="item in roomList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="clear">取 消</el-button>
      <el-button type="primary" @click="sendSubmit" :loading="btnLoading"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      sendData: {
        id: "",
        title: "",
        sendType: 0,
        type: "",
        target: "",
        titleAssistant: "",
        content: "",
        radioType: 1,
        ridgepoleId: "",
        unitId: "",
        floorId: "",
        roomId: "",
        type: 1,
      },
      btnLoading: false, //提交按钮加载
      sendFlags: true,
      orderId: "",
      sendDataRules:{
      },
      ridgepoleList: [],
      unitList: [],
      floorList: [],
      roomList: [],
    };
  },
  mounted() {
    this.$Apis.houseAllList().then((res) => {
      if (res.code == 200) {
        this.ridgepoleList = res.data;
      }
    });
  },
  methods: {
    clear(){
        this.$emit('isShowSend',false)
    },
    sendSubmit(){
      let data = {
        range:this.sendData.sendType,
        entityId:this.orderId,
        ridgepoleIds:Array.isArray(this.sendData.ridgepoleId)?this.sendData.ridgepoleId.join(','):this.sendData.ridgepoleId,
        unitIds:Array.isArray(this.sendData.unitId)?this.sendData.unitId.join(','):this.sendData.unitId,
        floorIds:Array.isArray(this.sendData.floorId)?this.sendData.floorId.join(','):this.sendData.floorId,
        roomIds:Array.isArray(this.sendData.roomId)?this.sendData.roomId.join(','):this.sendData.roomId,
        sendType:this.sendData.type,
        villageId:JSON.parse(localStorage.getItem('park_data')).id
      }
      this.$emit('sendSubmit',data)
    },    
    changeFlags() {
      if (this.sendData.radioType == 1) {
        this.sendData.ridgepoleId = [];
        this.sendData.unitId = "";
        this.sendData.floorId = "";
        this.sendData.roomId = "";
      } else if (this.sendData.radioType == 2) {
        this.sendData.ridgepoleId = null;
        this.sendData.unitId = [];
        this.sendData.floorId = "";
        this.sendData.roomId = "";
      } else if (this.sendData.radioType == 3) {
        this.sendData.ridgepoleId = "";
        this.sendData.unitId = "";
        this.sendData.floorId = [];
        this.sendData.roomId = "";
      } else if (this.sendData.radioType == 4) {
        this.sendData.ridgepoleId = "";
        this.sendData.unitId = "";
        this.sendData.floorId = "";
        this.sendData.roomId = [];
      }
      (this.unitList = []), (this.floorList = []), (this.roomList = []);
    },
    // 选择楼栋
    ridgepoleSelect(e) {
      if (this.sendData.radioType != 1 || this.sendData.sendType == -1) {
        this.$Apis.unitAllList({ ridgepoleId: e }).then((res) => {
          if (res.code == 200) {
            this.unitList = res.data;
          }
        });
      }
    },
    // 选择单元
    unitSelect(e, row) {
      if (
        (this.sendData.radioType != 1 && this.sendData.radioType != 2) ||
        this.sendData.sendType == -1
      ) {
        this.$Apis.floorAllList({ unitId: e }).then((res) => {
          if (res.code == 200) {
            this.floorList = res.data;
          }
        });
      }
    },
    // 选择楼层
    floorSelect(e) {
      if (
        (this.sendData.radioType != 1 &&
          this.sendData.radioType != 2 &&
          this.sendData.radioType != 3) ||
        this.sendData.sendType == -1
      ) {
        this.$Apis.roomAllList({ floorId: e }).then((res) => {
          if (res.code == 200) {
            this.roomList = res.data;
          }
        });
      }
    },
  },
};
</script>

<style>
</style>